import React from 'react'
import PropTypes from 'prop-types'

class LocationSelectNoAll extends React.Component {
  state = {
    locationId: this.props.locationId
  }

  onLocationChange = (e) => {
    this.setState({ locationId: e.target.value })
    setTimeout(function() { this.props.newLocationCallback(this.state.locationId); }.bind(this), 50)
  }

  render() {
    var options = this.props.locations.map(function(location) {
      return (
        <option key={location.id}
                title='Locations'
                value={location.id}>
          {location.name}
        </option>
      );
    });

    return(
      <div className={this.props.selectClassName}>
        <select className='form-control'
                title='Locations'
                value={this.state.locationId}
                onChange={(e) => this.onLocationChange(e)}>
          {options}
        </select>
      </div>
    )
  }
}

LocationSelectNoAll.propTypes = {
  locationId: PropTypes.number,
  locations: PropTypes.array,
  selectClassName: PropTypes.string
}

export default LocationSelectNoAll
